/**
 * Lightweight per-browser usage counters, incremented as the user interacts
 * with the daily features. Backs the profile's "Account Statistics" with real
 * (if local) numbers instead of placeholders.
 */
export type UsageStat = "tarot" | "runes" | "numerology" | "matches"

const STORAGE_KEY = "usage_stats"

export type UsageStats = Record<UsageStat, number>

const EMPTY: UsageStats = { tarot: 0, runes: 0, numerology: 0, matches: 0 }

export function readUsage(): UsageStats {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? { ...EMPTY, ...JSON.parse(raw) } : { ...EMPTY }
  } catch {
    return { ...EMPTY }
  }
}

export function bumpUsage(stat: UsageStat): void {
  try {
    const stats = readUsage()
    stats[stat] = (stats[stat] ?? 0) + 1
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stats))
  } catch {
    // ignore quota / privacy-mode failures
  }
}
